module.exports = __webpack_public_path__ + "34ece8d79ecadccc9122ae0505ebe3f5.woff2";